// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"4c87773d","453":"acfe974f","806":"87a4c338"}[chunkId] + ".chunk.js";
};